/*
 drawer event bus
*/
import Vue from 'vue';

export const drawerBus = new Vue();
